import { useLang } from '@/i18n/LanguageContext';

interface HeroProps {
  onRequestAccess: () => void;
  onWatchDemo: () => void;
}

export default function Hero({ onRequestAccess, onWatchDemo }: HeroProps) {
  const { t } = useLang();
  return (
    <section className="hero section" data-screen-label="Hero">
      <div className="hero-aura" />
      <div className="container">
        <div className="hero-split">
          <div className="hero-copy reveal in">
            <span className="badge">
              <span className="pill">{t('hero.badge.pill')}</span>
              <span>{t('hero.badge.text')}</span>
            </span>
            <h1>
              {t('hero.h1.line1')}
              <br />
              <span className="accent">{t('hero.h1.line2')}</span>
              <br />
              <span className="soft">{t('hero.h1.line3')}</span>
            </h1>
            <p className="lead">{t('hero.lead')}</p>
            <div className="hero-cta">
              <button type="button" className="btn btn-primary btn-lg" onClick={onRequestAccess}>
                {t('hero.cta.request')}
                <svg className="ic" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M4 10h12m0 0-4.5-4.5M16 10l-4.5 4.5"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <button type="button" className="btn btn-ghost btn-lg" onClick={onWatchDemo}>
                <svg className="ic" viewBox="0 0 20 20" fill="none">
                  <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.6" />
                  <path d="M8.5 7.5l4 2.5-4 2.5v-5Z" fill="currentColor" />
                </svg>
                {t('hero.cta.demo')}
              </button>
            </div>
            <div className="chips">
              <span className="chip chip--key">
                <span className="dot" />
                {t('hero.chip.migration')}
              </span>
              <span className="chip">{t('hero.chip.approve')}</span>
              <span className="chip">{t('hero.chip.extension')}</span>
              <span className="chip">{t('hero.chip.crm')}</span>
            </div>
          </div>

          {/* product screenshot window */}
          <div className="hero-vis reveal in" data-d="1">
            <div className="browser mock hero-shot" id="heroBrowser">
              <div className="browser-bar">
                <div className="traffic">
                  <i />
                  <i />
                  <i />
                </div>
                <div className="url">
                  <svg viewBox="0 0 16 16" fill="none">
                    <path
                      d="M4 7V5.5a4 4 0 1 1 8 0V7m-9 0h10v7H3V7Z"
                      stroke="currentColor"
                      strokeWidth="1.3"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span>mail.google.com</span>
                </div>
              </div>
              <img
                className="hero-shot-img"
                src="/images/hero-product.png"
                alt="Mindstream running inside Gmail — inbox, Account Brief, and CRM Sync"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
